export default "__VITE_ASSET__Ch7sfgQ7__"